import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    Output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateTime } from 'luxon';
import {
    formatApiDate,
    parseDateTime,
} from '../../../shared/date/date.utils';

@Component({
    selector: 'text-input',
    templateUrl: 'text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => TextInputComponent),
        },
    ],
    standalone: false
})
export class TextInputComponent implements ControlValueAccessor {
    @Input() public mask: string | undefined | null = null;
    @Input() public clearIfNotMatch = false;
    @Input() public dropSpecialCharacters = false;
    @Input() public placeholder = '';
    @Input() public errorMsg = '';
    @Input() public prefix = '';
    @Input() public type: 'text' | 'date' | 'numeric' = 'text';
    @Input() public maxDate = formatApiDate(
        DateTime.local().plus({ years: 100 }),
    );
    @Input() public minDate = formatApiDate(
        DateTime.local().minus({ years: 100 }),
    );
    @Input() public isDisabled = false;
    @Input() public maxLength: number | string | null = null;
    @Output() public onChange: EventEmitter<string> = new EventEmitter();
    @Output() public blur = new EventEmitter();

    @Input('value') public _value = '';
    public set value(value: string) {
        this._value = value;
        this.propagateChange(this._value);
        this.onChange.next(value);
    }
    public get value(): string {
        return this._value;
    }

    public inputFocused = false;

    public propagateChange = (_: any) => {};

    public registerOnTouched(fn: any): void {}

    public registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    public writeValue(value: any): void {
        if (value !== undefined) {
            this.value = value;
        }
    }

    public changeInput(event: Event) {
        const target = event.target as HTMLInputElement;
        this.value = target.value;
    }

    public changeDateInput(event: Event) {
        const target = event.target as HTMLInputElement;
        const date = parseDateTime(target.value, 'dd.MM.yyyy');
        if (date) this.value = formatApiDate(date);
    }

    public blurInput() {
        this.inputFocused = false;
        this.blur.next(undefined);
    }

    public focusInput() {
        this.inputFocused = true;
    }
}
